import React, { Fragment } from 'react';
import { PropTypes } from 'prop-types';

export default function AppAuth({ children }) {
  return <Fragment>{children}</Fragment>;
}

AppAuth.propTypes = {
  children: PropTypes.element.isRequired,
};
